
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.194 8.724a8.333 8.333 0 11-16.667 0 8.333 8.333 0 0116.667 0zm-9.297 4.412l6.183-6.182c.21-.21.21-.55 0-.76l-.76-.761a.538.538 0 00-.761 0l-5.042 5.042-2.355-2.354a.538.538 0 00-.76 0l-.76.76c-.21.21-.21.55 0 .76l3.494 3.495c.21.21.55.21.76 0z","fill":"#33C173"}})])
          )
        }
      }
    